export type PermissionItem = {
  key: string,
  title: string,
  is_enabled: boolean,
  user_types: string[],
}

export type BrandCustomProfileModel = {
  id: number,
  brand_id: number,
  cache_key: number,
  permission_data: { [key: string]: PermissionItem[] } | {},
  profile_type: string,
  role_id: number,
  title: string,
}

export type BrandCustomProfileRequestOptions = {}

const state = {
  id: undefined,
  brand_id: undefined,
  permission_data: {},
  profile_type: '',
  role_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'brand_id' },
  { key: 'permission_data' },
  { key: 'profile_type' },
  { key: 'role_id' },
  { key: 'title' },
]

export default state
